import { PaymentMethodsDb } from '../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

export interface JournalEntriesWaitingForReportFilterType {
  fromDate: Date | null;
  toDate: Date | null;
  paymentMethod: PaymentMethodsDb[];
  chartOfAccountIds: number[];
}

export const defaultJournalEntriesWaitingForReportFilter =
  (): JournalEntriesWaitingForReportFilterType => ({
    fromDate: null,
    toDate: null,
    paymentMethod: [],
    chartOfAccountIds: [],
  });
